export enum dietEnum {
    'dietUsuals' = 'dietUsuals',
    'dietPrescriptions' = 'dietPrescriptions',
}
